export default "__VITE_ASSET__AKIuyOFc__"